export default class TaskPriorityService {
    static get High() {
        return {
            id: 3,
            label: "High",
        };
    }
    static get Medium() {
        return {
            id: 2,
            label: "Medium",
        };
    }
    static get Low() {
        return { id: 1, label: "Low" };
    }
    static get Priorities() {
        return [
            TaskPriorityService.High,
            TaskPriorityService.Medium,
            TaskPriorityService.Low,
        ];
    }
}
